import { ServiceLink, ServiceNavigation, useFocus } from '@netapp/bxp-design-system-react';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import useCurrentService from 'utils/useCurrentService';
import { leftNav as i18nNamespace } from "../../../../../../i18n/namespace";
import { useListNavigation } from '../hooks';
import styles from '../CategoriesNav.module.scss';

const SelectedServiceNav = React.memo(({isShowingCategoriesNav = false}) => {
    const servicesByTo = useSelector(state => state.menu.servicesByTo);
    const { t } = useTranslation(i18nNamespace);
    const selectedService = useCurrentService();
    const navRefs = useRef([]);
    const { onFocus, onBlur } = useFocus();
    const location = useLocation();
    const activeFeatures = useSelector(state => state.features.active);

    const match = location.pathname.match(/(?<initialPath>\/[^/]+)/);
    const activeService = (servicesByTo && servicesByTo[match.groups.initialPath]) ?? selectedService?.uiIntegration;
    const { createKeyDownHandler, handleFocus } = useListNavigation(activeService?.subTabs, navRefs, { onItemClick: true });
    if (!activeService) {
        return null;
    }

    if (!match?.groups?.initialPath) {
        return null;
    }

    const onFocusHandler = (index) => {
        onFocus();
        handleFocus(index);
    }

    const isActiveTab = (location, serviceItem) => {
        const { pathname } = location;
        const baseRoute = `${selectedService?.service?.to}${serviceItem.to}`;
        
        if (pathname === baseRoute) {
            return true;
        }
        if (serviceItem.childRoutes) {
            return serviceItem.childRoutes.some((route) => pathname.startsWith(route));
        } 
        if (serviceItem.childRoutesFixed) {
            return serviceItem.childRoutesFixed.some((route) => pathname === route);
        }
        return pathname.startsWith(baseRoute);
    };

    const getRoute = (serviceItem) => {
        return serviceItem.isIndependentRoute ? serviceItem.to : `${selectedService?.service?.to}${serviceItem.to}`;
    }

    const renderServiceItems = (isShowingCategoriesNav) => {
        if (activeService?.subTabs && activeService.subTabs.length > 0) {
            return activeService.subTabs.map((serviceItem, index) => {
                if(!serviceItem.featureId || activeFeatures[serviceItem.featureId]) {
                    return (
                        <ServiceLink
                            tabIndex={isShowingCategoriesNav ? -1 : 0}
                            key={serviceItem.to}
                            exact
                            to={getRoute(serviceItem)}
                            isActive={(match, location) => isActiveTab(location, serviceItem)}
                            serviceLinkRef={(el) => navRefs.current[index] = el}
                            onFocus={() => onFocusHandler(index)}
                            onBlur={onBlur}
                            onKeyDown={createKeyDownHandler(index)}
                        >
                            {t(serviceItem.label)}
                        </ServiceLink>
                    );
                }
                return null;
            });
        }
        else {
            return <ServiceLink
                to={selectedService?.service?.to}
                onFocus={onFocus}
                key={`${selectedService?.key}-overview`}
                isActive={() => true}
            >
                {t("Overview")}
            </ServiceLink>;
        }
    };

    return <ServiceNavigation label={t(selectedService?.service?.serviceNavigationName ? selectedService?.service?.serviceNavigationName : selectedService?.name)} containerClassName={styles['show-service-menu']}>
        {renderServiceItems(isShowingCategoriesNav)}
    </ServiceNavigation>
}); 

export default SelectedServiceNav;